<template>
  <form class="patrocinador-form" @submit.prevent="submitForm" method="POST">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Seu nome"
        v-model="form.name"
        :disabled="disabled == 1"
        required
      />
      <input
        type="text"
        class="form-control"
        placeholder="Seu e-mail"
        v-model="form.email"
        :disabled="disabled == 1"
        required
      />
      <the-mask
        aria-label="Telefone"
        name="phone"
        :masked="true"
        class="form-control"
        placeholder="Telefone"
        v-model="form.phone"
        :disabled="disabled == 1"
        :mask="['(##) ####-####', '(##) #####-####']"
        required
      />
      <input
        type="text"
        class="form-control"
        placeholder="Empresa"
        v-model="form.company"
        :disabled="disabled == 1"
        required
      />
    </div>
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        v-model="form.privacy_policy"
        :disabled="disabled == 1"
        id="modal-checkbox"
        required
      />
      <label class="form-check-label">
        Concordo com a
        <a :href="this.privacy_policy" rel="noreferrer" target="_blank"
          >Política de Privacidade</a
        >
      </label>
    </div>
    <p>
      Ao concordar com a política de privacidade, você aceita receber contatos
      via, Telefone, mensagem pelo WhatsApp e E-mails com conteúdos de Negócios
      e informativos do Evento Acelera.
    </p>
    <button
      type="submit"
      class="button-verde"
      data-toggle="modal"
      data-target="#modal"
      sid="button-f"
    >
      {{ button }}
    </button>
  </form>
</template>
<style lang="scss" scoped></style>

<script>
import { TheMask } from "vue-the-mask";
import axios from "axios";
export default {
  data() {
    return {
      button: "Quero ser um patrocinador",
      disabled: 0,
      form: {
        name: "",
        email: "",
        phone: "",
        company: "",
        privacy_policy: "",
      },
    };
  },
  methods: {
    resetForm() {
      this.form = {
        name: "",
        email: "",
        phone: "",
        company: "",
        privacy_policy: "",
      };
    },
    submitForm() {
      this.button = "Enviando...";
      this.disabled = 1;
      axios
        .post(this.endpoint, this.form)
        .then((response) => {
          this.resetForm();
        })
        .catch((e) => {
          this.button = "Por favor, tente novamente.";
          // var button = document.getElementById('button-f');
          // button.classList.remove('button-verde');
          // button.classList.add('button-vermelho');
          this.resetForm();
        })
        .finally(() => {
          this.button = "Quero ser um patrocinador";
          this.disabled = 0;
        });
    },
  },
  props: ["endpoint", "privacy_policy"],
};
</script>
